/*
 * @Description:
 * @Author: JDY
 * @Date: 2021-04-14 19:18:15
 * @LastEditTime: 2021-05-25 18:20:29
 * @LastEditors: JDY
 */
import { requestData, requestGet } from '@/api/api'
import pick from 'lodash.pick'
const list = {
    data () {
        return {
            labelCol: {
                lg: { span: 6 },
                md: { span: 6 },
                sm: { span: 6 },
                xs: { span: 24 }
            },
            wrapperCol: {
                lg: { span: 14 },
                md: { span: 14 },
                sm: { span: 14 },
                xs: { span: 24 }
            },
            EditorCol: {
                lg: { span: 18 },
                md: { span: 18 },
                sm: { span: 18 },
                xs: { span: 24 }
            },
            loading: false,
            formLoading: false, // 表单加载
            form: this.$form.createForm(this) // 表单数据
        }
    },
    methods: {
        /**
         * 获取表单数据
         * @jdy
         * @2021-4-19
         */
        getFormData (id, callback) {
            const { apiList } = this
            this.loading = true
            requestGet(apiList.getInfo + id)
                .then(res => {
                    const { result } = res
                    if (callback) {
                        callback(result)
                    }
                    this.$nextTick(() => {
                        this.form.setFieldsValue(pick(result, this.fields))
                    })
                })
                .finally(() => {
                    this.loading = false
                })
        },
        /**
         * 表单提交
         * @param {*} e
         * @jdy
         * @2021-4-14
         */
        handleSubmit (callback) {
            console.log('callback')
            console.log(callback)
            const that = this
            const { apiList } = this

            that.form.validateFields((err, values) => {
                if (!err) {
                    that.formLoading = true // 表单加载
                    if (callback) {
                        callback(values)
                    }
                    let method = 'post'
                    let url = apiList.create
                    if (that.$route.params.id) {
                        method = 'put'
                        url = apiList.update + that.$route.params.id
                    }
                    requestData(url, method, values)
                        .then(res => {
                            that.$confirm({
                                title: res.msg,
                                okText: that.$route.params.id ? '继续编辑' : '继续添加',
                                cancelText: '返回列表',
                                onOk () {
                                    if (!that.$route.params.id) {
                                        that.form.resetFields()
                                    }
                                },
                                onCancel () {
                                    that.$router.go(-1)
                                }
                            })
                        })
                        .finally(() => {
                            that.formLoading = false // 执行完加载关闭
                        })
                }
            })
        }
    },
    created () {}
}
export default list
